// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jSo6","buttons":"styles_buttons__If-vZ"};